import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "../helpers/ScrollToTop";
import HomePage from "../pages/HomePage";
import MainPage from "../pages/MainPage";
import PlayerPage from "../pages/PlayerPage";
import RegisterPage from "../pages/RegisterPage";

export const AppRouter = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/live" element={<HomePage />} />
        <Route path="/player" element={<PlayerPage />} />
        <Route path="/registro" element={<RegisterPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};
